import { lazy } from "react"

const AdminLayout = lazy(() =>  import("./modules/admin/layout/Layout"))
// const AuthLayout = lazy(() =>  import("./modules/authentication/layout/Layout"))
const Logout = lazy(() =>  import("./modules/authentication/containers/Logout"))
const VaccinationScolaireFolder = lazy(() => import("./modules/admin/containers/vaccination/VaccinationScolaireFolder"))

export default {
  admin: {
    path: "/admin",
    component: AdminLayout
  },
  // auth: {
  //   path: "/auth",
  //   component: AuthLayout
  // },
  logout: {
    path: "/logout",
    component: Logout
  }
}
